module.exports = __webpack_public_path__ + "static/img/img8.a32fe62.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img8.jpg
// module id = ToAP
// module chunks = 0